<template>
  <input @change="onChange" :placeholder="placeholder" class="ad_input" />
</template>

<script>
export default {
  name: 'Button',
  props: ['placeholder'],
  data () {
    return  {
      input: ''
    }  
  },
  methods: {
    onChange (e) {
      this.input = e.target.value
      this.$emit('setInput', this.input)
    }
  }
};
</script>

<style>
  .ad_input{
    background: #FFFFFF;
    border-radius: 4px 0px 0px 4px;
    border: 2px solid #8D919B;
    height: 48px;
    width: 410px;
    cursor: pointer;
    padding-left: 24px;
    font-size: 16px;
    font-family: Helvetica;
  }
  .ad_input:focus{
    border: 2px solid #FC5322;
    caret-color: #FC5322;
  }

  @media (max-width: 767px){
    .ad_input{
      height: .8rem;
      padding: 0.17rem 0;
      font-size: .32rem;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/input/input.vue